/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientDiagnosisSuggestions = sqliteTable('patient_diagnosis_suggestions', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  ai_analysis_run_id: text('ai_analysis_run_id'),
  source_provider: text('source_provider'),
  diagnosis_text: text('diagnosis_text'),
  condition: text('condition'),
  severity: text('severity'),
  confidence: real('confidence'),
  status: text('status'),
  accepted_label: text('accepted_label'),
  accepted_diagnosis_entry_id: text('accepted_diagnosis_entry_id'),
  accepted_by: text('accepted_by'),
  accepted_at: text('accepted_at'),
  dismissed_by: text('dismissed_by'),
  dismissed_at: text('dismissed_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
